import { useRef } from 'react';

import {
  type NWTEvent,
  useTracking as useTrackingNWT,
} from '@xing-com/crate-communication-tracking';

export type TrackInViewParams = {
  itemUrn?: string;
  trackingToken?: string;
  context?: string;
  position: number;
};

type UseTrackingReturn = {
  trackInView: (props: TrackInViewParams) => void;
  trackClickOnFilter: () => void;
  trackFilterSelection: (filterSelected: string) => void;
};

import { useSearchAndShuffleContext } from './context';

export function useTracking(): UseTrackingReturn {
  const { track: trackNwt } = useTrackingNWT<NWTEvent>();
  const trackedInView = useRef<string[]>([]);
  const { config } = useSearchAndShuffleContext();

  // card entered viewport
  const trackInView = ({
    itemUrn,
    trackingToken,
    context,
    position,
  }: TrackInViewParams): void => {
    const trackInViewConfig = config.tracking?.trackInView?.();

    if (
      trackInViewConfig &&
      itemUrn &&
      !trackedInView.current.includes(itemUrn)
    ) {
      trackNwt({
        itemUrn,
        trackingToken,
        position,
        context,
        ...trackInViewConfig,
      });
      trackedInView.current.push(itemUrn);
    }
  };

  const trackClickOnFilter = (): void => {
    const trackClickOnFilter = config.tracking?.trackClickOnFilter?.();
    if (trackClickOnFilter) {
      trackNwt(trackClickOnFilter);
    }
  };

  const trackFilterSelection = (filterSelected: string): void => {
    const trackClickOnFilter =
      config.tracking?.trackFilterSelection?.(filterSelected);
    if (trackClickOnFilter) {
      trackNwt(trackClickOnFilter);
    }
  };

  return {
    trackInView,
    trackClickOnFilter,
    trackFilterSelection,
  };
}
